module.exports = __webpack_public_path__ + "static/media/js.0ef090cf.png";